export default [
  {
    path: '/approval-work-flows',
    name: 'approval-work-flow',
    meta: { requiresAuth: true },
    component: () => import('@/pages/approval-work-flow/index.vue')
  }
]
